var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgYe = function SvgYe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640V472.79H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f10600",
    d: "M0 0h640v157.374H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 322.624h640v157.374H0z"
  }))));
};
export default __webpack_public_path__ + "assets/d61828d4b7d588233807655491424d06.svg";
export { SvgYe as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ye.svg